var UserSession = {

    UserName: '',
    UserFullName: '',
    UserGuid: '',
    UserID: 0,
    BranchID: 0,
    ProvinceID: 0,
    RoleID: 0,
    DashboardURL: '',
    MenuType: '',
    MenuModel: [],
    TransactionCount: 0,
    SysproCompanyID: 0,
    JWT : ''
}

export default UserSession;
